import styled from "styled-components/macro";

import hbGuideBanner from "../../../../assets/banner/construction_road_map_bg_pic.jpg";

const HbGuideWrapper = styled.div`
  padding: 0 0 75px 0;
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
    z-index: -1;

    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.4) 0%,
      rgba(0, 0, 0, 0.3) 35%,
      rgba(0, 0, 0, 0.2) 100%
    );
  }
`;

export default HbGuideWrapper;
